import { Element } from "@siteimprove/alfa-dom";
import { PseudoClassSelector } from "./pseudo-class.js";
const { isElement } = Element;
/**
 * {@link https://drafts.csswg.org/selectors/#first-child-pseudo}
 */
export class FirstChild extends PseudoClassSelector {
    static of() {
        return new FirstChild();
    }
    constructor() {
        super("first-child");
    }
    *[Symbol.iterator]() {
        yield this;
    }
    matches(element) {
        return element
            .inclusiveSiblings()
            .filter(isElement)
            .first()
            .includes(element);
    }
    toJSON() {
        return super.toJSON();
    }
}
(function (FirstChild) {
    FirstChild.parse = PseudoClassSelector.parseNonFunctional("first-child", FirstChild.of);
})(FirstChild || (FirstChild = {}));
//# sourceMappingURL=first-child.js.map